import React from 'react';
import {withRouter} from 'react-router-dom';
class ScrollToTop extends React.Component {
    constructor(props, context) {
        super(props, context)
    }
    componentDidUpdate(prevProps){
       // console.log(this.props.location.pathname,prevProps.location.pathname);
         if(this.props.location.pathname!==prevProps.location.pathname){
            // console.log("scroll");
           // window.scroll(0, window.pageYOffset - 50);
           // window.scrollTo(0,0);
           document.body.scrollTo(0,0);
         }

    }
    render(){
           return this.props.children;

    }
}
export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/component/ScrollToTop.js